export const getMarketNameProps = (selection) => {
    return {
        phrase: selection.marketDisplayName
    };
};
//# sourceMappingURL=getMarketNameProps.js.map